import { render, staticRenderFns } from "./AbbreviatedTextTooltip.vue?vue&type=template&id=b4d36166"
import script from "./AbbreviatedTextTooltip.vue?vue&type=script&lang=js"
export * from "./AbbreviatedTextTooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports